// extracted by mini-css-extract-plugin
module.exports = {"activity-section":"activity-section__1Labx","icon":"icon__33cbK"};